import React from 'react';
import {
  Box,
  Button,
  Grid,
  Paper,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import RefreshIcon from '@mui/icons-material/Refresh';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import CommitIcon from '@mui/icons-material/Commit';
import { BasicCodeCombo } from '../core/BasicCodeCombo';

type Props = {
  scenarioCode: string;
  fiscalYear: string;
  forecastType?: string;
  scenarios: any[];
  forecastTypes?: any[];
  filename?: string;
  loading?: boolean;
  onScenarioChange: (v: string) => void;
  onFiscalYearChange: (v: string) => void;
  onForecastTypeChange: (v: string) => void;
  onRefresh: () => void;
  onImport?: () => void;
  onCommit?: () => void;
  onFile?: () => void;
};
class ForecastFilterBar extends React.Component<Props> {
  render() {
    const p = this.props;
    return (
      <Paper elevation={1} sx={{ p: 2, mb: 3 }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems={{ xs: 'stretch', md: 'center' }}
          spacing={2}
          sx={{ mb: 2 }}
        >
          <Box>
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              Forecast Controls
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Load, import and commit determinant forecast datasets.
            </Typography>
          </Box>
          <Stack direction="row" spacing={1}>
            <Button
              variant="outlined"
              startIcon={<RefreshIcon />}
              onClick={p.onRefresh}
              disabled={p.loading}
            >
              Refresh
            </Button>
            {p.onImport && (
              <Button
                variant="outlined"
                startIcon={<UploadFileIcon />}
                onClick={p.onImport}
                disabled={p.loading}
              >
                Import
              </Button>
            )}
            {p.onCommit && (
              <Button
                variant="contained"
                startIcon={<CommitIcon />}
                onClick={p.onCommit}
                disabled={p.loading}
              >
                Commit
              </Button>
            )}
          </Stack>
        </Stack>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 3 }}>
            <BasicCodeCombo
              label="Scenario"
              items={p.scenarios || []}
              value={p.scenarioCode || ''}
              onChange={(v: string) =>
                p.onScenarioChange(String(v || '').toUpperCase())
              }
              disabled={p.loading}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 2 }}>
            <TextField
              size="small"
              label="Fiscal Year"
              value={p.fiscalYear || ''}
              onChange={(e) => p.onFiscalYearChange(e.target.value)}
              fullWidth
              disabled={p.loading}
            />
          </Grid>
          {/* <Grid size={{ xs: 12, md: 3 }}>
            <BasicCodeCombo
              label="Forecast Type"
              items={p.forecastTypes || []}
              value={p.forecastType || ''}
              onChange={(v: string) =>
                p.onForecastTypeChange(String(v || '').toUpperCase())
              }
              disabled={p.loading}
            />
          </Grid> */}
          <Grid size={{ xs: 12, md: 5 }}>
            <TextField
              label="Selected Workbook"
              value={this.props.filename}
              fullWidth
              slotProps={{ input: {readOnly: true} }}
            />
          </Grid>
          <Grid size={{ xs: 12, md: 2 }}>
            <Button
              variant="outlined"
              component="label"
              fullWidth
              sx={{ height: '100%' }}
            >
              Select File
              <input
                hidden
                type="file"
                accept=".xlsx,.xls"
                onChange={this.props.onFile}
              />
            </Button>
          </Grid>
        </Grid>
      </Paper>
    );
  }
}
export default ForecastFilterBar;
